import React, { useState, useEffect, useRef } from 'react';
import './ChatBot.css';

interface IChatAPI {
  getMessages: (threadId: string) => Promise<any>; 
  postUser: () => Promise<any>; 
  postMessage: (message: string, threadId: string) => Promise<any>;
  postVerification: (code: string, threadId: string, verificationType: string) => Promise<any>;
}

interface ChatBotProps {
  name: string;
  api: IChatAPI;
}

interface Message {
  id: number;
  text: string;
  sender: 'user' | 'assistant';
  options?: string[];
  verificationType?: 'phone' | 'email';
  verificationStatus?: 'unknown' | 'correct' | 'incorrect';
  verificationCode?: string;  // this is not stored in the database, will blank out on refresh
}



const ChatBot: React.FC<ChatBotProps> = () => {
  // this is all duplicate code from CarAssistant.tsx
  // find a way to avoid doing this, especially if the code changes more
  const [messages, setMessages] = useState<Message[]>([]);
  const [currentInput, setCurrentInput] = useState('');
  const [threadId, setThreadId] = useState('');
  const [loadingMessage, setLoadingMessage] = useState(false);
  const [verificationCode, setVerificationCode] = useState(Array(6).fill(""));

  return (
    <></>
  );

  /*
  const inputRef = useRef<HTMLInputElement[]>([]);

  const messagesEndRef = useRef(null);

  const pageTitle = name === 'wolf' ? 'Wolf of Wall Street' : 'Car Assistant';

  const storageName = name === 'wolf' ? 'wolf_thread_id' : 'car_assistant_thread_id';

  const scrollToBottom = () => {
    (messagesEndRef.current as HTMLElement | null)?.scrollIntoView({ behavior: "smooth" });
  }


  useEffect(() => {
    async function fetchChat() {
      try {
        setLoadingMessage(true);
        const thread_id = localStorage.getItem(storageName);
        if (thread_id && thread_id.trim() !== 'undefined' && thread_id.trim() !== '') {
          console.log('stored thread_id found: ', thread_id);

          const response = await api.getMessages(thread_id)
          console.log('getMessages response.messages: ', response.messages);
          
          // this takes the message format that is returned by the thread messages API
          // will need to adjust this for format we send back with messages coming from the DB
          // const newMessages = response.messages.map((msg: any) => ({
          //   id: msg.id, 
          //   text: msg.content[0]?.text?.value, 
          //   sender: msg.role === 'assistant' ? 'assistant' : 'user',
          // })).reverse();

          const newMessages = response.messages.map((msg: any) => ({
            id: msg.id, 
            text: msg.text, 
            sender: msg.sender,
            options: msg.options,
            verificationType: msg.verification_type,
            verificationStatus: msg.verification_status,
          }));

          console.log('newMessages: ', newMessages);
          
          setMessages((prevMessages) => [...prevMessages, ...newMessages]);
          
          setThreadId(thread_id);
          setLoadingMessage(false);
        } else { 
          console.log('No stored thread_id found');
          
          const response = await api.postUser()
          console.log('postUser response: ', response);
          const thread_id = response['thread_id'];
          setThreadId(thread_id);
          localStorage.setItem(storageName, thread_id);

          const messagesResponse = await api.getMessages(thread_id)

          const newMessages = messagesResponse.messages.map((msg: any) => ({
            id: msg.id, 
            text: msg.text, 
            sender: msg.sender,
            options: msg.options,
          }));

          console.log('Get initial assistant message, messages: ', newMessages);
          setMessages((prevMessages) => [...prevMessages, ...newMessages]);
          setLoadingMessage(false);
        }
      } catch (error) {
        console.error('Error fetching chat:', error);
        setLoadingMessage(false);
      }
    }
    fetchChat();
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const sendVerificationCode = async (code: string) => {
    console.log('sending verification code: ', code);
    const response = await api.postVerification(code, threadId, 'phone');
    console.log('reply from BE: ', response);
    return response.success
  };


  const handleInputChange = async (event: React.FormEvent<HTMLInputElement>, index: number, messageId: number) => {
    const inputElement = event.target as HTMLInputElement;
    // Allow only numbers
    const newDigit = inputElement.value.slice(-1).replace(/[^0-9]/, '');

    // Prevent non-numeric input from being displayed
    if (!newDigit) {
      inputElement.value = ""; // Clear the input if the input is not a digit
        return; // Exit the function if no valid digit is entered
    }

    setMessages((prevMessages) => {
      let isLastDigit = false;
      const updatedMessages = prevMessages.map((message) => {
          if (message.id === messageId) {
              let updatedCode = message.verificationCode || "";
              updatedCode = `${updatedCode.substring(0, index)}${newDigit}${updatedCode.substring(index + 1)}`;

              // Check if this update completes the code
              isLastDigit = index === 5 && updatedCode.length === 6;
              
              return { ...message, verificationCode: updatedCode };
          }
          return message;
      });

      // If the last digit was entered, trigger verification
      if (isLastDigit) {
          const messageToUpdate = updatedMessages.find(m => m.id === messageId);
          if (messageToUpdate && messageToUpdate.verificationCode?.length === 6) {
              // Async operation outside `setMessages` but still based on its immediate result
              verifyCode(messageToUpdate.verificationCode?? "", messageId);
          }
      }

      return updatedMessages;
    });

    // Focus management
    const nextElement = inputRef.current[index + 1];
    if (nextElement && index < 5) {
        nextElement.focus();
    }
  };

  const verifyCode = async (code: string, messageId: number) => {
    console.log('verifying code: ', code);
    setLoadingMessage(true);
    const success = await sendVerificationCode(code);
    setLoadingMessage(false);
    const verificationStatus = success ? 'correct' : 'incorrect';
    setMessages(prevMessages => prevMessages.map(message => {
        if (message.id === messageId) {
            return { ...message, verificationStatus };
        }
        return message;
    }));
  };

  const handleVerificationSend = async (messageId?: number, verificationCode?: string) => {
    const success = await sendVerificationCode(verificationCode?? "");
    // Update the message in state with the new verification status
    setMessages((prevMessages) => prevMessages.map((message) => {
      if (message.id === messageId) {
        return { ...message, verificationStatus: success };
      }
      return message;
    }));
  }

  

  
  const handleSendMessage = async (message: string) => {
    console.log('handleSendMessage: ', message);
    if (!message.trim()) return; // Prevent sending empty messages

    setLoadingMessage(true);

    const userMessageText = message;
    setCurrentInput(''); 

    const userMessage: Message = {
      id: messages.length, // Simple ID assignment
      text: userMessageText,
      sender: 'user', 
    };
    setMessages([...messages, userMessage]);

    console.log('sending message to BE: ', userMessageText, ', thread_id: ', threadId);
    const response = await api.postMessage(userMessageText, threadId);
    console.log('Reply from BE: ', response);

    const assistantMessage: Message = {
      id: messages.length + 1, // Simple ID assignment
      text: response.message.text,
      sender: 'assistant', 
      options: response.message.options,
      verificationType: response.message.verificationType,
    };

    setMessages([...messages, userMessage, assistantMessage]);

    setLoadingMessage(false);

  };

  const handleFocus = (event: any) => {
    event.target.select();
  };

  return (
    
    <div className="central-column">
      <br/>
      <h1>{pageTitle}</h1>
      <br/>
      <div className="messages-container">
        {messages.map((message) => (
          <div key={message.id} style={{
            margin: '1rem',
            textAlign: message.sender === 'user' ? 'right' : 'left',
            backgroundColor: message.sender === 'assistant' ? '#f0f0f0' : 'transparent',
            padding: '0.5rem',
            borderRadius: '0.5rem',
            whiteSpace: 'pre-wrap',
          }}>
            <>
              <span>{message.sender === 'user' ? 'You: ' : 'Assistant: '}</span>{message.text}
              {Array.isArray(message.options) && message.options.length > 0 && (
                <div style={{ marginTop: '0.5rem' }}>
                  {message.options.map((option, index) => (
                    <button key={index} onClick={() => handleSendMessage(`${option}`)} className="option-buttons btn btn-outline-primary">
                      {option}
                    </button>
                  ))}
                </div>
              )}
              {message.verificationType === 'phone' && (
                <div className="verification-container">
                  {Array.from({ length: 6 }).map((_, index) => (
                    <input
                      key={index}
                      className="verification-digit"
                      type="text"
                      maxLength={1}
                      onInput={(e) => handleInputChange(e, index, message.id)}
                      onFocus={handleFocus}
                      disabled={message.verificationStatus === 'correct' || loadingMessage}
                      ref={(el) => inputRef.current[index] = el!} // Storing each input ref
                    />
                  ))}
                  
                  <span className="verification-check">
                  {
                    message.verificationStatus !== 'correct' && !loadingMessage ?
                    <i className="bi bi-arrow-up-square-fill" onClick={() => handleVerificationSend(message.id, message.verificationCode)}></i>
                    :
                    <i className="bi bi-arrow-up-square-fill disabled-icon"></i> 
                  }
                  </span>
                  <span className="verification-check">
                    {message.verificationStatus === 'correct' && <i className="bi bi-check-square" style={{color: 'green'}}></i>}
                    {message.verificationStatus === 'incorrect' && <i className="bi bi-x-square" style={{color: 'red'}}></i>}
                  </span>
                </div>
              )}
            </>
          </div>
        ))}
        {loadingMessage && 
          <div className='typing-indicator-container'>
            <div className="typing-indicator">
              <span></span><span></span><span></span>
            </div>
          </div>
        }
        <div ref={messagesEndRef} />
      </div>
      <div className='input-container'>
        <input
          type="text"
          value={currentInput}
          onChange={(e) => setCurrentInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) { 
              handleSendMessage(currentInput);
              e.preventDefault(); // Prevent the default action to avoid form submission if wrapped in a form
            }
          }}
          disabled={loadingMessage}
        />
        <i className="bi bi-arrow-up-square-fill" onClick={() => handleSendMessage(currentInput)}></i>
      </div>
    </div>
  );
  */
};

export default ChatBot;